import axios from 'axios'
// import meters from '../store/Modules/meters'

// console.log(meters.state.token);
// let tk = `Bearer ${meters.state.token}`

const apiMeterClient = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers:{
        "Content-Type": "application/json",
        "auth-api": process.env.VUE_APP_TOKEN_API
    }
})

const responseInterceptor = response => {
    const OK_CODE = 200
    // console.log(meters.state.token);
    if (response.status == OK_CODE) return response.data
    else return Promise.reject(response)
}

apiMeterClient.interceptors.response.use(responseInterceptor)

export default apiMeterClient
